import type { ActionTree } from 'vuex'
import type { FacebookMessengerIntegrationState } from './types'
import type { RootState } from '@/store/modules/types'
import { getContext } from '@/utils/general'

export const facebookMessengerIntegrationActions: ActionTree<FacebookMessengerIntegrationState, RootState> = {
  async FETCH_FACEBOOK_PAGES({ state, commit, rootState }) {
    if (!rootState.authModule.account) { return null }
    const { promoterOid } = rootState.authModule.account

    const { $axios } = getContext()

    try {
      commit('SET_IS_FETCHING_FACEBOOK_PAGES', true)
      const params = {
        $filter: 'app=messenger AND (authorized OR paymentSubscriptionOid IS NOT NULL)',
        $top: 'all',
      }

      // @ts-ignore
      const { data } = await $axios.sg.get(`/promoter/${promoterOid}/integration-subscription`, {
        params,
      })

      commit('SET_FACEBOOK_PAGES', data)

      return data
    }
    catch (error) {
      throw error
    }
    finally {
      commit('SET_IS_FETCHING_FACEBOOK_PAGES', false)
      commit('SET_HAS_FETCHED_INITIAL_FACEBOOK_PAGES', true)
    }
  },

  async FETCH_INTEGRATION({ state, commit, rootState }) {
    if (!rootState.authModule.account) { return null }
    const { promoterOid } = rootState.authModule.account

    try {
      commit('SET_IS_FETCHING_INTEGRATION', true)
      const filterString = encodeURI(`app=messenger and provider=facebook`)
      // @ts-ignore
      const { data } = await $axios.sg.get(`/promoter/${promoterOid}/integration?$filter=${filterString}`)
      commit('SET_INTEGRATION', data[0])
    }
    catch (err) {
      console.error(err)
      commit('SET_INTEGRATION', null)
    }
    finally {
      commit('SET_IS_FETCHING_INTEGRATION', false)
      commit('SET_HAS_FETCHED_INTEGRATION', true)
    }
  },
}
